$(document).ready(function() {
  $("#promo-form #is-precentage").change(function() {
    showHidePercentage($(this));
  });

  function showHidePercentage(input){
    if ($(input).is(':checked')) {
      $("#amount-percent").removeClass('hide');
      $("#promotion").addClass('hide');
      $("#promotion-input").prop('disabled', true);
      $("#promotion-input").prop('required', false)
      $("#amount-percent-input").prop('disabled', false);
      $("#amount-percent-input").prop('required', true)
    } else {
      $("#promotion").removeClass('hide');
      $("#amount-percent").addClass('hide');
      $("#amount-percent-input").prop('disabled', true);
      $("#amount-percent-input").prop('required', false)
      $("#promotion-input").prop('disabled', false);
      $("#promotion-input").prop('required', true)
    }
  }
})